import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { reduxForm } from 'redux-form';
import BlockUI from '../../component/BlockUI';
import CustomerType from '../../component/CustomerType';

var _ = require('lodash');
var numeral = require('numeral');

const current_year = parseInt(moment().format("YYYY"));
let year_list = _.range(2018, current_year + 1);
// Tính toán tiền dịch vụ.
function ItemPrice(item) {
  let item_price = item.price;
  if(!item.is_upgrade && !item.price_is_year) {
    item_price = item.price * item.month * item.quantity
  }
  return item_price;
}
function AgencyRows(data) {
  const dataSort = _.orderBy(data, [function(item) { return ItemPrice(item.invoice_item) - item.invoice_item.invoice.total }], ["desc"])
  const rows = _.map(dataSort, function(i, index) {
    return (
      <tr key={index}>
        <td>
          {i.agency.email}
          <br/>
          <small>{i.agency.full_name}-{i.agency.phone}</small>
        </td>
        <td>
          {i.agency.sale ? i.agency.sale.email : "N/A"}
          <br/>
          <small className="display-block text-muted text-size-small">
            {i.agency.sale ? i.agency.sale.full_name : "N/A"}
          </small>
        </td>
        <td >
          {CustomerType(i.agency)}
        </td>
        <td>
          <Link to={"/admin/invoice/detail/"+i.invoice_item.invoice_id}>{i.invoice_item.invoice.code}</Link>
        </td>
        <td>
            <strong>{i.invoice_item.product.name}</strong>
            <br/>
            <small className="text-muted">
              {i.invoice_item.product.code}
              <br/>
              {i.invoice_item.domain}
            </small>
          </td>
        <td className="text-orange">
          {numeral(ItemPrice(i.invoice_item)).format("0,0")}
        </td>
        <td className="text-orange">
          {numeral(i.invoice_item.invoice.total).format("0,0")}
        </td>
        <td className="text-purple">
          <strong> {numeral(ItemPrice(i.invoice_item) - i.invoice_item.invoice.total).format("0,0")}</strong>
        </td>
      </tr>
    )
  })
  return rows;
}

class InvoiceWrongPriceTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      table_data: [],
      table_query: {
        sort_asc: false,
        year: current_year
      },
      isLoading: false,
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }
  
  listReload = (table_query) => {
    const self = this;
    this.setState({
      isLoading: true
    })
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice/wrong/price/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data,
        isLoading: false
      })
    });
  }

  onChangeYear = (year) => {
    const { table_query } = this.state;
    const data = {
      ...table_query,
      year: year
    }
    this.listReload(data)
  }

  render() {
    const { handleSubmit, role_path } = this.props;
    const { table_query, table_data, isLoading, billing_data } = this.state;
    const year = table_query.year;
    const year_option = _.map(year_list, (i,index) => <option key={index} value={i}>Năm: {i}</option>);

    return(
      <React.Fragment>
        {isLoading && <BlockUI />}
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <ToastContainer />
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold"> Đơn Hàng Sai Giá</span>
              </h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <form style={{display:"inline-flex"}}>
                <div style={{ width:"100%", paddingRight:5}}>
                <select
                  style={{ maxWidth: "100px", minWidth: "350px" }} 
                  className="form-control"
                  value={year}
                  onChange={(event) => this.onChangeYear(parseInt(event.target.value))}>
                  {year_option}
                </select>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="table-responsive">
                <div style={{margin:10}} className="text-align-right">
                </div>
                <table className="table table-togglable table-hover">
                  <thead>
                    <tr>
                      <th data-toggle="true">
                        Email
                        <br/>
                        <small className="display-block text-muted text-size-small">Họ Tên - Điện Thoại</small>
                      </th>
                      <th data-hide="phone">
                        Sale Man
                      </th>
                      <th data-hide="phone">
                        Loại
                      </th>
                      <th data-hide="phone">
                        Mã Đơn Hàng
                      </th>
                      <th>
                        Dịch Vụ
                      </th>
                      <th>
                        Tổng tiền dịch vụ
                      </th>
                      <th>
                        Tổng tiền đơn hàng
                      </th>
                      <th>
                        Chênh Lệch
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data && AgencyRows(table_data)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}


const mapState = state => ({
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({
});


const InvoiceWrongPriceTableWrapper = reduxForm({
  form: 'InvoiceWrongPriceTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(InvoiceWrongPriceTable);

export default connect(mapState, mapDispatch)(withRouter(InvoiceWrongPriceTableWrapper));
